import BandPage from '../../components/BandPage';
import { Sparkles } from 'lucide-react';
export default function ReinigungsplanPage() {
  return <BandPage bandType="putzen" pageTitle="Reinigungsplan" icon={Sparkles} />;
}
